




















































import Vue from 'vue';
import { Prop, Watch } from 'vue-property-decorator';
import { clone } from 'lodash';
import Component from 'vue-class-component';
import BaseComponent from '@/components/base-component.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import { getProducts } from '@/services/products';

@Component({
  components: {
    PermissionAuth,
  },
})
export default class ClientUnitProducts extends BaseComponent {
  @Prop()
  public value: any[];
  @Prop({
    default: false,
  })
  public isEdit: boolean;

  private products: any[] = [];
  private productsSelec: any[] = [];
  private productAdd: any = null;
  private loading: boolean = false;
  public headers: any = [    
    { text: 'Código', value: 'codigo', sortable: true },
    { text: 'Descrição', value: 'descricao', align: 'left', sortable: true },
    { text: 'Grupo', value: 'grupo', align: 'left', sortable: true },
    { text: 'Subgrupo', value: 'subgrupo', align: 'left', sortable: true },
    { text: 'Ações', value: 'actions', align: 'right', sortable: false },
  ];

  @Watch('value')
  private onValueChange() {
    this.productsSelec = Object.assign([], this.value);
  }

  private onProdsChange() {
    this.$emit('input', this.productsSelec);
  }

  public beforeMount(): void {
    this.getProducts();
  }

  private getProducts(): void {
    this.loading = true;
    const filter = { status: true };
    getProducts(filter).subscribe(
      (data) => {
        this.products = data.map((item) => {
          return {
            id: item.id,
            descricaofull: item.codigo + ' - ' + item.descricao,
            codigo: item.codigo,
            descricao: item.descricao,
            subgrupo: item.subgrupo.nome,
            grupo: item.subgrupo.grupo.nome
          };
        });
        this.loading = false;
      },
      (error) => {
        this.loading = false;
      },
    );
  }

  private getAvailableItems(): any[] {
    return this.products.filter((p) => !this.productsSelec.filter((sp) => sp != null && sp.id == p.id).length);
  }

  private addProd() {
    this.productsSelec.push(this.productAdd);
    setTimeout(() => {
      this.onProdsChange();
      this.productAdd = null;      
    }, 200);
  }

  private deleteProd(prod) {
    this.productsSelec.splice(this.productsSelec.indexOf(prod), 1);
    setTimeout(() => {
      this.onProdsChange();      
    }, 200);
  }

}
